/* Coshi — rupee normalisation, display only.

   This store's Shopify money format is "Rs. {{amount}}" (and the with-currency
   format appends " INR"), but every line of copy on the site is written with
   ₹. Left alone, a product card reads "Rs. 1,949" directly under a ticker that
   says "₹1,949", and the product page puts "Pay ₹1 today" next to
   "Rs. 1,949" — which reads as carelessness.

   THE REAL FIX IS A STORE SETTING: Settings > Store details > Currency
   formatting, set to ₹{{amount}}. That cannot be changed over the Admin API,
   so this rewrites the rendered text instead. Once the setting is changed this
   file becomes a no-op and can be deleted.

   Text nodes only — no attributes, no values, nothing a script reads back. Dawn
   re-renders cart and price fragments after quantity changes, so newly inserted
   subtrees are normalised too. The observer watches childList only and this
   edits characterData, so it cannot retrigger itself. */
(function () {
  'use strict';

  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1 };

  function fix(root) {
    if (!root || !root.nodeType) return;
    var walker, node, hits = [];
    try {
      walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    } catch (e) { return; }
    while ((node = walker.nextNode())) {
      if (!node.nodeValue) continue;
      if (node.nodeValue.indexOf('Rs.') === -1 && node.nodeValue.indexOf('INR') === -1) continue;
      var p = node.parentNode;
      if (!p || SKIP[p.tagName]) continue;
      hits.push(node);
    }
    for (var i = 0; i < hits.length; i++) {
      hits[i].nodeValue = hits[i].nodeValue
        .replace(/Rs\.\s?/g, '₹')
        .replace(/\s?\bINR\b/g, '');
    }
  }

  function run() {
    fix(document.body);
    try {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            if (added[j].nodeType === 1) fix(added[j]);
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else { run(); }
})();
